export default __webpack_public_path__ + "3c0061988dd179664115c6f3cf75c0a5.svg";